import { call, fork, put } from 'redux-saga/effects'
import { takeEvery } from 'redux-saga'
import * as api from '../services/indexdb'
import type { Procedure } from '../../../../app-core/lib/procedure/Procedure'
import { isDeleted } from '../../utils/sync'
import type { Form_IForm } from '../../../zap/Form/Form.types'
import type {
    Type_IActionType,
    Type_ICalendarEvent,
    Type_ILocation,
    Type_ILocationFocusList,
    Type_IReport,
    Type_IUnit,
    Type_IUnitList,
    Type_Workflow,
} from '../../../zap/Type/Type.hive'
import {
    receiveActionTypes,
    receiveActivities,
    receiveCalendarEvents,
    receiveCampaigns,
    receiveFocusLists,
    receiveForms,
    receiveLocations,
    receiveReports,
    receiveUnitList,
    receiveUnits,
    receiveUnitTypes,
    SYNC_ACTION_TYPES,
    SYNC_ACTIVITIES,
    SYNC_ALL,
    SYNC_CALENDAR_EVENTS,
    SYNC_CAMPAIGNS,
    SYNC_FOCUS_LISTS,
    SYNC_FORMS,
    SYNC_LOCATIONS,
    SYNC_REPORTS,
    SYNC_UNIT_LISTS,
    SYNC_UNIT_TYPES,
    SYNC_UNITS,
} from '../actions/entities'
import type { AppUnitType } from '../../../../shared/domain/units/types.no-deps'

export function* getActivities() {
    const data: Type_Workflow[] = yield call(api.fetchActivities)
    yield put(receiveActivities(data))
}

export function* getActionTypes() {
    const data: Type_IActionType[] = yield call(api.fetchActionTypes)
    yield put(receiveActionTypes(data))
}

export function* getCalendarEvents() {
    const events: Type_ICalendarEvent[] = yield call(api.fetchCalendarEvents)
    const data = events.filter((event) => !isDeleted(event))
    yield put(receiveCalendarEvents(data))
}

export function* getCampaigns() {
    const data: Procedure[] = yield call(api.fetchCampaigns)
    yield put(receiveCampaigns(data))
}

export function* getFocusLists() {
    const focusLists: Type_ILocationFocusList[] = yield call(api.fetchFocusLists)
    yield put(receiveFocusLists(focusLists))
}

export function* getForms() {
    const data: Form_IForm[] = yield call(api.fetchForms)
    yield put(receiveForms(data))
}

export function* getLocations() {
    const data: Type_ILocation[] = yield call(api.fetchLocations)
    yield put(receiveLocations(data))
}

export function* getReports() {
    const data: Type_IReport[] = yield call(api.fetchReports)
    yield put(receiveReports(data))
}

export function* getUnits() {
    const data: Type_IUnit[] = yield call(api.fetchUnits)
    yield put(receiveUnits(data))
}

export function* getUnitTypes() {
    const data: AppUnitType[] = yield call(api.fetchUnitTypes)
    yield put(receiveUnitTypes(data))
}

export function* getUnitLists() {
    const data: Type_IUnitList[] = yield call(api.fetchUnitLists)
    yield put(receiveUnitList(data))
}

export function* watchSyncEntities() {
    yield takeEvery(SYNC_ACTIVITIES, getActivities)
    yield takeEvery(SYNC_ACTION_TYPES, getActionTypes)
    yield takeEvery(SYNC_CALENDAR_EVENTS, getCalendarEvents)
    yield takeEvery(SYNC_CAMPAIGNS, getCampaigns)
    yield takeEvery(SYNC_FOCUS_LISTS, getFocusLists)
    yield takeEvery(SYNC_FORMS, getForms)
    yield takeEvery(SYNC_FOCUS_LISTS, getFocusLists)
    yield takeEvery(SYNC_LOCATIONS, getLocations)
    yield takeEvery(SYNC_REPORTS, getReports)
    yield takeEvery(SYNC_UNITS, getUnits)
    yield takeEvery(SYNC_UNIT_TYPES, getUnitTypes)
    yield takeEvery(SYNC_UNIT_LISTS, getUnitLists)

    yield takeEvery(SYNC_ALL, getEntities)
}

export function* getEntities() {
    yield fork(getActivities)
    yield fork(getActionTypes)
    yield fork(getCalendarEvents)
    yield fork(getCampaigns)
    yield fork(getFocusLists)
    yield fork(getForms)
    yield fork(getLocations)
    yield fork(getReports)
    yield fork(getUnits)
    yield fork(getUnitTypes)
    yield fork(getUnitLists)
}

export default function* root() {
    yield fork(watchSyncEntities)
}
